import { batch, signal } from "@preact/signals-react"

// Selected SKU
export const selectedSku = signal(null) // { value: id_sku, label: name, image_url: ... }

// Data
export const skuDetailData = signal(null)
export const isLoading = signal(false)

// Date filter
export const selectedDays = signal(7)
export const DAYS_OPTIONS = [
    { value: 7, label: 'Last 7 days' },
    { value: 14, label: 'Last 14 days' },
    { value: 30, label: 'Last 30 days' },
    { value: 90, label: 'Last 90 days' },
    { value: 365, label: 'Last year' }
]

// Market filter
export const marketFilter = signal(null)

// Stock filter
export const onlyInStock = signal(false)

// Clear all signals
export const clearPriceAnalysisSignals = () => batch(() => {
    selectedSku.value = null
    skuDetailData.value = null
    isLoading.value = false
    selectedDays.value = 7
    marketFilter.value = null
    onlyInStock.value = false
})

// Clear only data (keep SKU selected)
export const clearData = () => batch(() => {
    skuDetailData.value = null
    marketFilter.value = null
    onlyInStock.value = false
})
